// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1lgE4","dragIcon":"Choice_dragIcon__3sVY9","left":"Choice_left__25t4e","input":"Choice_input__3VevL"};